import { useCallback, useState } from 'react';
import { projects } from '../projects';
const order = ['bsp', 'qattal', 'messaging', 'interview', 'airtime', 'broker', 'sports'];

export default function Projects() {
  const [selected, setSelected] = useState(order[0]);
  const selectProject = useCallback(event => setSelected(event.currentTarget.dataset.project), []);
  const project = projects[selected];
  return <section id="work" className="page"><span className="eyebrow">/work</span>
    <div className="page-heading"><h1>Products.<br />Built to work<span className="name-dot">.</span></h1>
      <span>SELECT A PROJECT<br />TO LOOK INSIDE ↓</span></div>
    <div className="explorer"><div className="project-menu" aria-label="Projects">
      {order.map((key, index) => <button key={key} data-project={key} onClick={selectProject}
        aria-pressed={selected === key}><span>0{index + 1}</span>{projects[key].title}
        <small>{projects[key].category}</small></button>)}</div>
      <article id="project-view"><div className="project-body">
        <span className="eyebrow">{project.category}</span><h2>{project.title}</h2>
        <p>{project.description}</p>
        {project.url && <a className="text-link" href={project.url} target="_blank" rel="noreferrer">
          Visit Ayara ↗
        </a>}<span className="eyebrow">MY CONTRIBUTION</span>
        <ul>{project.points.map(point => <li key={point}>{point}</li>)}</ul>
        <p className="stack">{project.stack}</p></div></article></div></section>;
}
